// @ts-ignore
import PROJECTS_SORT_OPTIONS from 'constants/projectsSortOptions';
import { ProjectsState } from './types';

const initialState: ProjectsState = {
  all: {
    isLoading: false,
    error: '',
    data: [],
  },
  list: {
    isLoading: false,
    error: '',
    isGrid: true,
    sortOptions: PROJECTS_SORT_OPTIONS,
    paginationOptions: {
      page: 1,
      size: 9,
      name__icontains: '',
      ordering: '-updated_at',
      archived: false,
    },
    data: {
      items: [],
      count: 0,
    },
  },
  add: {
    isLoading: false,
    error: '',
  },
  import: {
    isLoading: false,
    error: '',
  },
  clone: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
